/// <amd-module name="Build/Admin/Checks/Stores/StoresHub" />
import { ActionsHub } from "Build/Admin/Checks/Actions/ActionsHub";
import { ChecksStore } from "Build/Admin/Checks/Stores/ChecksStore";
import { NotificationStore } from "Build/Admin/Common/Stores/NotificationStore";
import { SecurityStore } from "Build/Admin/Checks/Stores/SecurityStore";
import { SelectionStore } from "Build/Admin/Checks/Stores/SelectionStore";

export class StoresHub {
    public checksStore: ChecksStore;
    public notificationStore: NotificationStore;
    public securityStore: SecurityStore;
    public selectionStore: SelectionStore;

    constructor(actionsHub: ActionsHub)  {
        this.checksStore = new ChecksStore();
        actionsHub.checkStoreStatusUpdated.addListener(this.checksStore.updateStatus);

        this.notificationStore = new NotificationStore();
        actionsHub.notificationActions.addNotification.addListener(this.notificationStore.addNotification);
        actionsHub.notificationActions.dismissNotification.addListener(this.notificationStore.dismissNotification);
        actionsHub.notificationActions.clearNotifications.addListener(this.notificationStore.clearNotifications);

        this.securityStore = new SecurityStore();
        actionsHub.securityStoreStatusUpdated.addListener(this.securityStore.updateStatus);
        actionsHub.managePermissionUpdated.addListener(this.securityStore.updateManagePermission);

        this.selectionStore = new SelectionStore();
        actionsHub.selectedAgentPoolUpdated.addListener(this.selectionStore.updateSelectedAgentPool);
        actionsHub.selectedAgentQueueUpdated.addListener(this.selectionStore.updateSelectedAgentQueue);
        actionsHub.selectedTabUpdated.addListener(this.selectionStore.updateSelectedTab);
    }
}
